export default {
  methods: {
    langCheck(LangMaster) {
      if(!this.$store.state.account.lang) {
        let langGet = navigator.language
        if(langGet === "ja") {
          this.lang = LangMaster['ja']
          this.noAuthLang = 'ja'
        } else {
          this.lang = LangMaster['en']
          this.noAuthLang = 'en'
        }
      } else {
        this.lang =  LangMaster[this.$store.state.account.lang]
      }
    }
  }
}
